import httpClient from "../../api/httpClient";
import Email from "../classes/EmailBroadcast";

interface HttpCalls {
    method: string;
    rota: string;
}

const calls: HttpCalls[] = [
    { method: "GET", rota: "Broadcast/EmailBroadcast/All" },
    { method: "GET", rota: "Broadcast/EmailBroadcast/{email}" },
    { method: "POST", rota: "Broadcast/EmailBroadcast/Adicionar" },
    { method: "PUT", rota: "Broadcast/EmailBroadcast/Atualizar" },
    { method: "DELETE", rota: "Broadcast/EmailBroadcast/Apagar" }
];

const cacheKey: string = "EmailCache";
const cacheKeySelC: string = "EmailSelecionado";

const apiServico: String = "PORTAL"

class EmailDataset extends httpClient {

    constructor() {
        super(String(apiServico));
    }

    async ListarAtivos(): Promise<Email[]> {
        return await super.Get(calls[0].rota)
            .then((response) => {
                return JSON.parse(JSON.stringify(response.data));
            })
            .catch((erro) => {
                console.error(erro)
            });
    }

    Adicionar(value: Email) {
        let ok: boolean = false;
        let error: any = undefined;
        super.post(calls[2].rota, value).then((result) => {
            ok = JSON.parse(result);
        }).catch((erro) => {
            ok = false;
            error = erro;
        });
        if (error !== undefined && ok === false)
            throw error;
    }

    Atualizar(value: Email) {
        let ok: boolean = false;
        let error: any = undefined;
        super.put(calls[3].rota, value).then((result) => {
            ok = JSON.parse(result);
        }).catch((erro) => {
            ok = false;
            error = erro;
        });
        if (error !== undefined && ok === false)
            throw error;
    }

    Apagar(value: Email) {
        let ok: boolean = false;
        let error: any = undefined;
        super.delete(calls[4].rota, value).then((result) => {
            ok = JSON.parse(result);
        }).catch((erro) => {
            ok = false;
            error = erro;
        });
        if (error !== undefined && ok === false)
            throw error;
    }



    getKeyCach(): string {
        return cacheKey;
    }

    getKeyCachClass(): string {
        return cacheKeySelC;
    }

    ListarFromCache(): Email[] {
        let result: Email[] = JSON.parse(cacheKey);
        return result;
    }

    AdicionarListaAoCache(value: Email[]) {
        localStorage.setItem(cacheKey, JSON.stringify(value));
    }

    LimparListaDoCache() {
        localStorage.removeItem(cacheKey);
    }

    AdicionarObjetoAoCache(value: Email) {
        localStorage.setItem(cacheKeySelC, JSON.stringify(value));
    }

    LimparObjetoDoCache() {
        localStorage.removeItem(cacheKeySelC);
    }

}
export default EmailDataset;